import React from "react";

const SupplementAnalysisResults = ({ response = {} }) => {
  let parsedResponse = response;
  console.log("opt parsed response", parsedResponse);

  try {
    if (typeof response === "string") {
      parsedResponse = JSON.parse(response);
    }
  } catch (error) {
    console.error("Error parsing JSON response:", error);
    parsedResponse = {};
  }

  const recommendations = parsedResponse?.Recommendations?.Recommendations?.[0] || {};
  const timingSchedule = parsedResponse?.TimingSchedule?.Structure?.[0]?.supplements || {};

  const renderTimingSection = (title, supplements) => {
    if (!supplements || supplements.length === 0) return null;
    
    return (
      <div className="mb-4">
        <h3 className="text-lg font-semibold capitalize mb-2">
          {title.replace(/_/g, ' ')}
        </h3>
        <ul className="space-y-2">
          {supplements.map((supplement, index) => (
            <li key={index} className="ml-4">
              <span className="font-medium">{supplement.name}</span> - {supplement.dosage}
              {supplement.frequency && ` ${supplement.frequency}`}
              {supplement.note && ` (${supplement.note})`}
              
              {/* (
                <p className="text-sm text-gray-600 mt-1">{supplement.note}</p>
              )} */}
            </li>
          ))}
        </ul>
      </div>
    );
  };

  const handlePrintView = () => {
    try {
      const resultsContent = document.getElementById("supplement-results")?.innerHTML;
      if (!resultsContent) return;

      const newWindow = window.open("", "_blank");
      if (newWindow) {
        newWindow.document.write(`
          <!DOCTYPE html>
          <html lang="en">
          <head>
              <meta charset="UTF-8">
              <meta name="viewport" content="width=device-width, initial-scale=1.0">
              <title>Print Supplement Analysis Results</title>
              <style>
                  body {
                      font-family: Arial, sans-serif;
                      margin: 20px;
                      line-height: 1.6;
                  }
              </style>
          </head>
          <body>
              ${resultsContent}
          </body>
          </html>
        `);
        newWindow.document.close();
      }
    } catch (error) {
      console.error("Error generating print view:", error);
    }
  };

  if (!parsedResponse || Object.keys(parsedResponse).length === 0) {
    return (
      <div className="p-4 text-center">
        <p className="text-gray-600">No supplement analysis data available.</p>
      </div>
    );
  }

  return (
    <div id="supplement-results">
      <div className="header">
        <h1>Your Supplement Optimization Results</h1>
      </div>
      <hr className="custom-line" />

      {/* Recommendations Section */}
      {Object.keys(recommendations).length > 0 && (
        <div className="section">
          <h2>General Recommendations</h2>
          <p>{parsedResponse?.Recommendations?.Overview}</p>
          <ul>
            {recommendations.InteractionWarnings && (
              <li><strong>Interaction Warnings:</strong> {recommendations.InteractionWarnings}</li>
            )}
            {recommendations.CyclingRecommendations && (
              <li><strong>Cycling Recommendations:</strong> {recommendations.CyclingRecommendations}</li>
            )}
            {recommendations.StorageRequirements && (
              <li><strong>Storage Requirements:</strong> {recommendations.StorageRequirements}</li>
            )}
            {recommendations.QualityConsiderations && (
              <li><strong>Quality Considerations:</strong> {recommendations.QualityConsiderations}</li>
            )}
            {recommendations.SafetyConsiderations && (
              <li><strong>Safety Considerations:</strong> {recommendations.SafetyConsiderations}</li>
            )}
          </ul>
        </div>
      )}

      {/* Optimized Timing */}
      {Object.keys(timingSchedule).length > 0 && (
        <div className="section">
          <h2>Supplements Optimized</h2>
          {renderTimingSection("Early Morning (Empty Stomach)", timingSchedule.morning_empty_stomach)}
          {renderTimingSection("First Meal", timingSchedule.first_meal)}
          {renderTimingSection("Afternoon Snack/Meal", timingSchedule.afternoon_snack)}
          {renderTimingSection("Last_Meal", timingSchedule.last_meal)}
          {renderTimingSection("Pre or Post Workout", timingSchedule.pre_post_workout)}
          {renderTimingSection("Monthly Cycle", timingSchedule.monthly_cycle)}
          
        </div>
      )}
    <p><em>This content is AI-generated and for informational purposes only. It is not a replacement for consulting a medical professional for specific supplements, amounts, or any health decisions.</em></p>
      <button
        id="print-view-button"
        className="button-style"
        onClick={handlePrintView}
      >
        Print View
      </button>
    </div>
  );
};

export default SupplementAnalysisResults;
